import { DbQuestion } from '~src/types/db';
import { DB_STATE } from '~src/types/enums';

/**
 * Filter and sort questions based on vendor/project side and sort order
 */
export const filterAndSortQuestions = (
  questions: DbQuestion[],
  isVendorSide: boolean,
  sortOrder: 'asc' | 'desc'
): DbQuestion[] => {
  let filtered = [...questions];

  if (isVendorSide) {
    // Vendor side: Only accepted questions with available answers
    filtered = filtered.filter((q) => {
      const isAccepted = q.state === DB_STATE.ACCEPTED;
      const hasValidAnswers = (q.answers || []).some(
        (a) => a.state !== DB_STATE.REJECTED && a.state !== DB_STATE.REMOVED
      );
      return isAccepted && hasValidAnswers;
    });
  } else {
    // Project side: Filter out rejected, removed, and ignored questions
    filtered = filtered.filter((q) => {
      const isValid =
        q.state !== DB_STATE.REJECTED &&
        q.state !== DB_STATE.REMOVED &&
        !q.report_data?.is_ignore;
      return isValid;
    });
  }

  // Sort by creation date
  filtered.sort((a, b) => {
    const dateA = a.created_at || 0;
    const dateB = b.created_at || 0;
    return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
  });

  return filtered;
};
